import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchProduct } from "features/hosting/hostingAPI";
import { fetchAddonsServer, fetchProductsPromoServer } from "./serverAPI";

const initialState = {
  products: [],
  addonsSpecial: [],
  addonsServer: [],
  operatingSystem: null,
  status: {
    products: "idle",
    addonsSpecial: "idle",
    addonsServer: "idle",
  },
  error: {
    products: "",
    addonsSpecial: "",
    addonsServer: "",
  },
};

export const getServerByGroup = createAsyncThunk(
  "server/getServerByGroup",
  async (gid) => {
    const response = await fetchProduct(gid);
    return response;
  }
);

export const getAddonsServer = createAsyncThunk(
  "server/getAddonsServer",
  async (pid) => {
    const response = await fetchAddonsServer(pid);
    return response;
  }
);

export const getProductsPromoServer = createAsyncThunk(
  "products/getFromGIDPromoServer",
  async (data) => {
    const response = await fetchProductsPromoServer(data);
    return response;
  }
);

const serverSlice = createSlice({
  name: "server",
  initialState,
  reducers: {
    updateOperatingSystem: (state, action) => {
      state.operatingSystem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getServerByGroup.pending, (state) => {
      state.status.products = "loading";
      state.products = [];
    });
    builder.addCase(getServerByGroup.fulfilled, (state, action) => {
      const { product } = action.payload.products;
      state.products = product;
      state.status.products = "idle";
    });
    builder.addCase(getServerByGroup.rejected, (state, action) => {
      state.status.products = "idle";
      state.products = [];
      state.error = action.error.message;
    });
    builder.addCase(getAddonsServer.pending, (state) => {
      state.status.addonsServer = "loading";
      state.addonsServer = [];
    });
    builder.addCase(getAddonsServer.fulfilled, (state, action) => {
      const { addons } = action.payload.data[0];
      state.addonsServer = addons;
      state.status.addonsServer = "idle";
    });
    builder.addCase(getAddonsServer.rejected, (state, action) => {
      state.status.addonsServer = "idle";
      state.addonsServer = [];
      state.error = action.error.message;
    });
    builder.addCase(getProductsPromoServer.pending, (state) => {
      state.status.products = "loading";
      state.products = [];
    });
    builder.addCase(getProductsPromoServer.fulfilled, (state, action) => {
      const { product } = action.payload.products;
      state.products = product;
      state.status.products = "idle";
    });
    builder.addCase(getProductsPromoServer.rejected, (state, action) => {
      state.status.products = "idle";
      state.products = [];
      state.error = action.error.message;
    });
  },
});

export const serverSelector = (state) => state.server;
export const { updateOperatingSystem } = serverSlice.actions;
export default serverSlice.reducer;